import React, { useEffect, useState } from 'react';

// Components
import ControlLinkItem from '@/views/components/navigation/ControlLinkItem';

// Utils
import { formatMessage } from '@/utils/i18n';
import { Tooltip } from '@capintel/component-lib/tooltip';
import { Button } from '@capintel/component-lib/button';

type NavigationSidebarItems = {
  id: string;
  value: string;
  label: string;
  icon?: string;
};

interface NavProps {
  items: NavigationSidebarItems[];
  defaultExpanded?: boolean;
  defaultActiveId?: string;
  onClick?: (id: string) => void;
}

const NavigationSidebar = ({ items, defaultExpanded, defaultActiveId, onClick }: NavProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const [activeItemId, setActiveItemId] = useState<string>(defaultActiveId || '');

  useEffect(() => {
    if (defaultActiveId) {
      setActiveItemId(defaultActiveId);
    }
  }, [defaultActiveId]);

  return (
    <div className="navigation-sidebar-container">
      <div className={`navigation-sidebar ${!isExpanded ? 'collapsed' : ''}`}>
        <div className="navigation-sidebar-toggle-button">
          <Tooltip content={formatMessage(isExpanded ? 'Common.Collapse' : 'Common.Expand')} data-testid="navigation-sidebar-toggle-tooltip">
            <Button variant="outline" appearance="icon" icon={isExpanded ? 'chevron-left' : 'chevron-right'} onClick={() => setIsExpanded(!isExpanded)} />
          </Tooltip>
        </div>

        <div className="navigation-sidebar-content">
          <nav className="navigation">
            {isExpanded && (
              <ul className="list">
                {items.map((item, index) => (
                  <ControlLinkItem
                    key={index}
                    className={`list-item ${activeItemId === item.id ? 'active' : ''}`}
                    ariaLabel={item.label}
                    route={item.value || '#'}
                    value={item.id}
                    onClick={() => {
                      setActiveItemId(item.id);
                      if (onClick) {
                        onClick(item.id);
                      }
                    }}
                  >
                    {item.icon && <i className={`icon-${item.icon}`} />}
                    <span className="item-label ellipsis">{item.label}</span>
                  </ControlLinkItem>
                ))}
              </ul>
            )}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default NavigationSidebar;
